/**
 * Cascader中间层，只用于状态传递
 */
import React, { useMemo } from 'react';
import { useIntl } from 'umi';
import { Checkbox } from 'tea-component';
import SingleMenuItem from './SingleMenuItem';
import ShortCut from './ShortCut';
import { ICascaderItemProps } from '../../../type';
import './index.scss';
import useIntlExtend from '@/pages/intelligence/hooks/useIntlExtend';
import { getShowLabel } from '@intelligence/components/Form/utils';

const SELECT_BTN_EN = ['Select All', 'Clear All'];
const SELECT_BTN_CN = ['全选', '清空'];

const getIsEmpty = (value: any): boolean => {
  if (Object.prototype.toString.call(value) === '[object Object]') {
    return Object.keys(value).filter((key) => value[key]?.length).length === 0;
  }
  return !value?.length;
};

export default function CascaderItem(props: ICascaderItemProps) {
  const {
    options,
    value,
    onItemClick,
    width = 250,
    onChange,
    category,
    hasSelectAll,
    hasHighlight,
    hasShortcut,
    selectedItem = { value: '' },
    onClickAll,
    searchKey = '',
    isGroup,
    shortcutOptions = [],
    shortcutDefaultValue = '',
    onShortcutItemClick,
    setIsChange,
    selectAllScope = 'all',
  } = props;
  const { locale } = useIntl();
  const { formatMessage } = useIntlExtend();

  const isEmpty = useMemo(
    () => getIsEmpty(value),
    [isGroup ? value : value?.length],
  );

  // 用于展示全选按钮的文案
  const displaySelectAllLabel = useMemo(() => {
    const target = locale === 'en-US' ? SELECT_BTN_EN : SELECT_BTN_CN;
    return isEmpty ? target[0] : target[1];
  }, [isEmpty, locale]);

  const handleClickAll = () => {
    if (!options?.length) return;
    setIsChange(true);
    onClickAll(selectedItem, !!isGroup, isEmpty, selectAllScope);
  };

  return (
    <div className="dbi-cascader-content-wrap" style={{ width: `${width}px` }}>
      {!!hasShortcut && (
        <ShortCut
          options={shortcutOptions}
          defaultValue={shortcutDefaultValue}
          onClick={onShortcutItemClick}
        />
      )}
      <div className="dbi-cascader-category-wrap">
        {category && (
          <span className="dbi-cascader-checkbox-title">{category}</span>
        )}
        {hasSelectAll && (
          <span className={`dbi-cascader-select-all ${options?.length ? '' : 'disabled'}`} onClick={handleClickAll}>
            {displaySelectAllLabel}
          </span>
        )}
      </div>
      <div className="dbi-cascader-checkbox tea-list--option">
        {options?.length ? (
          <Checkbox.Group>
            {options?.map((item) => (
              <SingleMenuItem
                key={item.value}
                isGroup={isGroup}
                formItem={item}
                formValue={value}
                isMutiple={true}
                hasHighlight={hasHighlight}
                searchKey={searchKey}
                isSelected={selectedItem?.value === item.value}
                onItemClick={onItemClick}
                onChange={onChange}
              />
            ))}
          </Checkbox.Group>
        ) : (
          <div className="dbi-cascader-empty">
            <span>
              {getShowLabel(
                { labelKey: 'dbi_search_no_result' },
                formatMessage,
              )}
            </span>
          </div>
        )}
      </div>
    </div>
  );
}
